import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-add-quiz',
  templateUrl: './add-quiz.component.html',
  styleUrls: ['./add-quiz.component.scss']
})
export class AddQuizComponent implements OnInit {

  constructor(public courseService: CourseService, private toastrService: ToastrService, private router: Router) { }
  public quizzesGroup: FormGroup;
  public degreeSymbol:string = '°';
  public questionGroup: FormGroup;
  public isUpdate: boolean = false;
  public courseId: any;
  public moduleId: any;
  public quizId: any;
  public selectedOptionIndex: any[] = [];
  public isLoading: boolean = false;
  ngOnInit(): void {
    let url = this.router.url.split('/');
    this.courseId = url[2];
    this.moduleId = url[4];
    this.quizId = url[6];
    this.onCreateQuestionGroup();
    this.quizzesGroup = new FormGroup({
      questions: new FormArray([])
    });
    this.courseService.getQuiz(this.courseId, this.moduleId, this.quizId).subscribe(
      (res: any) => {
        if (res.questions.length) {
          for (let i = 0; i < res.questions.length; i++) {
            let obj = {
              question: res.questions[i].question,
              options: [...res.questions[i].options],
              answer: res.questions[i].answer
            };
            this.questionGroup.patchValue({ ...obj });
            this.selectedOptionIndex.push(0);
            (this.quizzesGroup.get('questions') as FormArray).push(_.cloneDeep(this.questionGroup));
          }
        }
        else {
          (this.quizzesGroup.get('questions') as FormArray).push(_.cloneDeep(this.questionGroup));
          this.selectedOptionIndex.push(0);
        }
      }
    )
  }

  onCreateQuestionGroup() {
    this.questionGroup = new FormGroup({
      question: new FormControl('', [Validators.required]),
      options: new FormArray([
        new FormControl('', [Validators.required]),
        new FormControl('', [Validators.required]),
        new FormControl('', [Validators.required]),
        new FormControl('', [Validators.required])
      ]),
      answer: new FormControl('', [Validators.required])
    });
  }

  addQuiz() {
    for (let i = 0; i < this.quizzesGroup.get('questions').value.length; i++) {
      if (((this.quizzesGroup.get('questions') as FormArray).at(i).get('options') as FormArray).at(i) && this.selectedOptionIndex[i])
        (this.quizzesGroup.get('questions') as FormArray).at(i).get('answer').setValue(((this.quizzesGroup.get('questions') as FormArray).at(i).get('options') as FormArray).at(this.selectedOptionIndex[i]).value);
    }
    if (this.quizzesGroup.valid) {
      this.isLoading = true;
      this.courseService.addQuiz(this.quizzesGroup.value, this.courseId, this.moduleId, this.quizId)
        .subscribe(
          (res) => {
            this.isLoading = false;
            history.back();
          }
        );
    }
    else {
      this.isLoading = false;
      this.toastrService.error('Please fill all the fields!');
    }
  }

  onAddDegreeSymbol(option:FormControl, index) {
    option.setValue(option.value + this.degreeSymbol);
  }

  onAddMoreQuiz() {
    this.onCreateQuestionGroup();
    (this.quizzesGroup.get('questions') as FormArray).push(_.cloneDeep(this.questionGroup));
    this.selectedOptionIndex.push(0);
  }

  onRemoveQuiz(index) {
    (this.quizzesGroup.get('questions') as FormArray).removeAt(index);
    this.selectedOptionIndex.splice(index, 1);
  }

  onClickCancel() {
    this.router.navigate([`courses/${this.courseId}/modules/${this.moduleId}/modify`]);
  }

  onClickRadioButton(outerIndex, innerIndex) {
    this.selectedOptionIndex[outerIndex] = innerIndex;
    let option = ((this.quizzesGroup.get('questions') as FormArray).at(outerIndex).get('options') as FormArray).at(innerIndex).value;
    ((this.quizzesGroup.get('questions') as FormArray).at(outerIndex).get('answer')).setValue(option);
  }

}
